var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPositiveAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.08409 10.6629H3.03364C1.91049 10.6629 1 11.5857 1 12.7242V19.9387C1 21.0771 1.91049 22 3.03364 22H6.08409M6.08409 10.6629L9.3393 3.23907C9.79 2.21121 10.9999 1.68012 11.9811 2.2056C13.5081 3.0234 13.2018 3.78995 13.2018 8.60158H18.9659C20.2123 8.60158 21.1654 9.72766 20.9759 10.9763L19.568 20.2521C19.4154 21.2577 18.5618 22 17.558 22H6.08409V10.6629ZM6.08409 10.6629V22V10.6629Z",
    stroke: "#1FD76D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositiveAlert);
export default __webpack_public_path__ + "static/media/positive-alert.c2dc3bcd689854e4eaf03a44fd6c6436.svg";
export { ForwardRef as ReactComponent };